export default "__VITE_ASSET__5040a430__"